<td><a routerLink="/patient/{{ patientTrialId }}">{{ patientCode }}</a></td>
<td>{{ trialCode }}</td>
<td>{{ trialNickname }}</td>
<td>{{ trialOpportunityNumber }}</td>
<td class="text-center">{{ date | date: 'd MMM yyyy' }}</td>
<td class="text-center">
  <app-star-rating [rating]="stars"></app-star-rating>
</td>
